<template>

    <OaoOverlay isSubmit v-if="show" :style="{ visibility: play ? 'visible' : 'hidden' }">
        <MemberLoader :source="source" :play="play" />
    </OaoOverlay>

</template>




<script>

import { OaoOverlay } from '@/components';
import MemberLoader from './MemberLoader';
import overlayData from './overlayData';

export default {

    name: 'MemberLoaderOverlay',
    mixins: [overlayData],
    components: {
        OaoOverlay,
        MemberLoader
    }

}

</script>